import urls from "./urls";

export default {
    //It's fetched from helper module in order to potentially use it in vuex store.
    methods: urls,
};
